<template>
    <div class="">

        <div class="d-flex justify-content-between align-items-center">
            <div class="">
                <h1 class="mb-0">Vendor Document Types</h1>
            </div>
            <div class="">
                <b-button
                    v-if="allowCreate"
                    variant="success"
                    :disabled="loadingMetadata || createLoading || sidebarShowing"
                    @click="showCreateModal"
                >Add Document Type</b-button>
                <!-- <b-button
                    variant="success"
                    @click="showStarter"
                >
                    Add New Requirement
                </b-button> -->
            </div>
        </div>

        <div class="mt-4">
            <div class="mb-2">
                <!-- buttons / actions / filters here -->
            </div>
            <b-card
                class="shadow-sm overflow-hidden rounded-lg"
                no-body
            >
                <b-table
                    primary-key="id"
                    ref="compItemsTable"
                    :items="compItems"
                    :fields="tableFields"
                    :busy="loadingList"
                    :sort-by.sync="sortByField"
                    :sort-desc.sync="sortDesc"
                    :per-page="perPage"
                    :current-page="currentPage"
                    hover
                    responsive
                    selectable
                    select-mode="single"
                    selected-variant="primary"
                    no-select-on-click
                    class="mb-0 bg-white no-top-border "
                >
                    <template #cell(title)="data">
                        <a :href="data.item.urls.internal_detail" class="font-weight-bold">{{ data.value }}</a>
                    </template>
                    <!-- <template #cell(title)="data">
                        <b-link
                            aria-controls="comp-item-detail-sidebar"
                            :aria-expanded="detailDataId === data.item.id ? 'true' : 'false'"
                            class="font-weight-bold"
                            @click="showDetail(data.item, data.index, $event)"
                        >{{ data.value }}</b-link> 
                    </template> -->
                    <template #cell(kindLabel)="data">
                        <CompKindChip :kind="data.item.kind"></CompKindChip>
                    </template>
                    <template #cell(allow_vendor_scopes)="data">
                        <CompSingleMultipleChip :value="data.value ? 'multiple' : 'single'"></CompSingleMultipleChip>
                    </template>
                    <template #cell(supplier_is_visible)="data">
                        <b-badge :variant="data.unformatted ? 'success' : 'soft-secondary'" class="text-uppercase">{{ data.value }}</b-badge>
                    </template>
                    <template #cell(supplier_can_upload)="data">
                        <b-badge :variant="data.unformatted ? 'success' : 'soft-secondary'" class="text-uppercase">{{ data.value }}</b-badge>
                    </template>
                    <template #cell(is_auto_renewal_enabled)="data">
                        <b-badge :variant="data.unformatted ? 'success' : 'soft-secondary'" class="text-uppercase">{{ data.value }}</b-badge>
                    </template>
                    <template #cell(requirement_id)="data">
                        <b-badge :variant="!!data.unformatted ? 'success' : 'soft-secondary'" class="text-uppercase">{{ data.value }}</b-badge>
                    </template>

                </b-table>
                <template #footer v-if="!loadingList && totalRows">
                    <base-table-pagination
                        :current-page.sync="currentPage"
                        :per-page.sync="perPage"
                        :per-page-options="perPageOptions"
                        :total-items="totalRows"
                        :show-per-page="showPerPage"
                        item-name="Document Types"
                    ></base-table-pagination>
                </template>
            </b-card>
        </div>

        <!-- <pre>{{ compItems }}</pre> -->

        <b-sidebar 
            v-model="sidebarShowing"
            id="comp-item-detail-sidebar"
            right 
            width="700px" 
            shadow
            lazy
            :aria-label="detailDataTitle"
            bg-variant="gray-100"
            body-class="py-4 px-3"
            @shown="handleSidebarShown"
            @hidden="handleSidebarHidden"
            @change="handleSidebarChange"
        >
            <!-- <transition name="fade-fast" mode="out-in"> -->
            <!-- TODO - make this work for CompItem/Vendor combos where you don't have VendorCompItem yet 
            make sure to get the right IDs for the right things (keys/sending to API, etc.) 
            -->
            <CompItemQuickView
                v-if="sidebarShowing && detailDataId"
                :key="detailDataId"
                :compItemId="detailDataId"
                @updated="refresh"
            />
            <!-- <pre>{{ detailData }}</pre> -->
            <!-- </transition> -->
        </b-sidebar>  


        <div class="">
            <b-modal
                v-model="createModalShowing"
                centered
                title="Add New Document Type"
                body-bg-variant="gray-100"
                content-class="overflow-hidden"
                hide-footer
            >
                <CompItemCreateForm
                    :enabledFields="['comp_item_type_id', 'kind_id', 'title', 'allow_vendor_scopes', 'enable_valid_dates']"
                    @cancel="handleCreateFormCancel"
                    @saved="handleCreateFormSaved"
                    @loading-status="handleCreateFormLoadingStatus"
                ></CompItemCreateForm>
            </b-modal>
        </div>

    </div>
</template>

<script>
import { suppliosApi } from "@/js/api-service";
import { errorHandling } from "@/js/custom-vue-mixins";
import CompItemCreateForm from "./CompItemCreateForm.vue";
import { FormatDateHelper } from "@/js/filters-helpers";
import { ComplianceItem } from "../shared/compModels";
import BaseTablePagination from '@/components/BaseTablePagination.vue';
import CompKindChip from '../shared/CompKindChip.vue';
import CompSingleMultipleChip from '../shared/CompSingleMultipleChip.vue';
import CompItemQuickView from './CompItemQuickView.vue';

export default {
    name: 'CompItemManageList',
    components: {
        CompItemCreateForm,
        BaseTablePagination,
        CompKindChip,
        CompSingleMultipleChip,
        CompItemQuickView,
    },
    mixins: [errorHandling],
    props: {},
    data() {
        return {
            loadingList: false,
            createLoading: false,
            compItems: [],
            loadingMetadata: false,
            hasCompItemTypesCanCreate: false,  // set based on what we get back from metadata call
            // LATER compItemTransitionStore: {},  // we stash available transitions here when we open the dropdown in a row
            createModalShowing: false,
            tableFields: [
                { key: 'title', label: 'Document Type', sortable: true, sortByFormatted: (val) => (val ? val.toLowerCase() : '') },
                { key: 'item_type.name', label: 'Document Category', sortable: true },
                // { key: 'categoryLabel', label: 'Category Type', class: 'text-center', sortable: true, sortByFormatted: true, formatter: (value, key, item) => (item.item_type?.category?.label || '') },  // sort by label, but show badges
                { key: 'kindLabel', label: 'Kind', class: 'text-center', sortable: true, sortByFormatted: true, formatter: (value, key, item) => (item.kind?.label || '') },  // sort by label, but show badges
                { key: 'supplier_is_visible', label: 'Supplier Visibility', class: 'text-center', sortable: true, sortByFormatted: true, formatter: (value) => value ? 'Visible' : 'Hidden' },
                { key: 'supplier_can_upload', label: 'Suppliers can upload?', class: 'text-center', sortable: true, sortByFormatted: true, formatter: (value) => value ? 'Yes' : 'No' },
                { key: 'is_auto_renewal_enabled', label: 'Auto-Renew Enabled?', class: 'text-center', sortable: true, sortByFormatted: true, formatter: (value) => value ? 'Yes' : 'No' },
                { key: 'requirement_id', label: 'Requirement Rules?', class: 'text-center', sortable: true, sortByFormatted: true, formatter: (value) => value ? 'Yes' : 'No' },
                { key: 'allow_vendor_scopes', label: 'Documents Per Vendor', class: 'text-center', sortable: true },
                { key: 'vci_count', label: 'Document Count', class: 'text-center', sortable: true },
                //{ key: 'sm_state', label: 'Status', sortable: true },
                { key: 'created', label: 'Created', sortable: true, formatter: (value) => FormatDateHelper(value) },
                // TO ADD
                // things about requirements attached
                // things about how many VCIs are attached
                // things about visibility (later)
            ],
            // SIDEBAR / DETAIL 
            sidebarShowing: false,
            detailData: {}, // set the status object here to show in the sidebar
            // PAGINATION
            showPerPage: true,
            perPage: 25,
            perPageOptions: [10, 25, 50, 100],
            currentPage: 1,
            sortByField: 'title',
            sortDesc: false,
        }
    },
    computed: {
        totalRows() {
            return this.compItems.length;
        },
        detailDataTitle() {
            return this.detailData?.title || 'Document Type Detail';
        },
        detailDataId() {
            return this.detailData?.id || '';
        },
        allowCreate() {
            return this.hasCompItemTypesCanCreate;  // maybe add more conditions, or add a prop to hide it
        },
    },
    created() {
        
    },
    mounted() {
        this.getList();
        this.getCreateMeta();
    },
    methods: {
        async refresh() {
            return await this.getList();
        },
        async getList() {
            this.loadingList = true;
            let resp;
            try {
                resp = await suppliosApi.compItemStd.list_comp_items_for_manage();
                this.compItems = Array.isArray(resp.data) ? resp.data.map(i => new ComplianceItem(i)) : [];
            } catch (e) {
                this.apiErrorHandler(e);
            }
            this.loadingList = false;
        },
        async getCreateMeta() {  // we load this (also in the form) but do it here just to know if we should show the create button
            this.loadingMetadata = true;
            let resp;
            try {
                resp = await suppliosApi.compItemStd.get_create_meta();
            } catch (error) {
                this.apiErrorHandler(error);
            }
            if (resp.data) {
                // TODO  stash the stuff you need for the form
                const rawItemTypes = Array.isArray(resp.data.item_types) ? resp.data.item_types : [];
                this.hasCompItemTypesCanCreate = rawItemTypes.length > 0;
            }
            this.loadingMetadata = false;
        },
        // CREATE MODAL
        showCreateModal() {
            this.createModalShowing = true;
        },
        handleCreateFormCancel() {
            this.createModalShowing = false;
        },
        handleCreateFormSaved() {
            this.createModalShowing = false;
            this.refresh();
        },
        handleCreateFormLoadingStatus(status) {
            this.createLoading = status;
        },
        // flow object starter
        showStarter() {
            const starter = this.$refs.flowStarter;
            if (starter) {
                starter.show();
            }
        },
        hideStarter() {
            const starter = this.$refs.flowStarter;
            if (starter) {
                starter.hide();
            }
        },
        // DETAIL
        selectTableRow(displayedRowIndex) {
            // pass in the index of the row in the table you want to show in selected state
            // hard to pass in the ID, since the index of each row changes based on filtering/sorting of the table
            // if you pass in a falsy value (excluding 0), it will clear the selected state
            // the table needs an index of the row... we'll look that up
            if (displayedRowIndex !== null && displayedRowIndex !== undefined) {
                if (displayedRowIndex > -1) {
                    this.$refs.compItemsTable?.selectRow(displayedRowIndex);
                }
            } else {
                this.$refs.compItemsTable?.clearSelected();
            }
        },
        showDetail(compItem, displayedRowIndex, event) {
            console.log('showDetail compItem, displayedRowIndex, $event', compItem, displayedRowIndex, event);
            this.detailData = compItem;
            this.sidebarShowing = true;
            // select the row in the table to show in selected state
            this.selectTableRow(displayedRowIndex);
        },
        handleSidebarHidden() {
            this.selectTableRow(null);  // unselect the row in the table
        },
        handleSidebarShown() {
            // do something when the sidebar is shown
            console.log('handleSidebarShown');
        },
        handleSidebarChange(newVal) {
            // handles @change event from b-sidebar, which is the v-model for sidebarShowing
            // ideally, we should not set v-model directly, that screws up assistive tech stuff
            // instead, we use v-b-toggle directive and update other things based on this emitted event
            // but we counldn't get that to work with the sidebar, so we're doing this
            console.log('handleSidebarChange', newVal);
            // this.sidebarShowing = newVal;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>